// Middleware to protect routes that require authentication
// This is separate from the parentAuth middleware which handles the app-specific parent authentication flow

import { useRuntimeConfig } from '#app'
import { useAzureAdAuth } from '~/composables/useAzureAdAuth'

export default defineNuxtRouteMiddleware((to) => {
  // Skip middleware on server (SSR disabled, but keep guard for safety)
  if (import.meta.server) return

  // Respect runtime flag to disable auth for testing
  const config = useRuntimeConfig()
  const authEnabled = String(config.public.authEnabled).toLowerCase() === 'true'
  if (!authEnabled) {
    console.log('[MIDDLEWARE] AzureAuth - Auth disabled via config, skipping')
    return
  }

  // Public routes that shouldn't require auth
  const publicRoutes = [
    '/',
    '/auth/login',
    '/auth/logout',
    '/auth/error',
    // Include any pickup routes that should remain public (and their children)
    '/pickup/auth',
  ]

  // Check if the current route is public (exact match or nested under a public prefix)
  const isPublicRoute = publicRoutes.some((route) => {
    if (route === '/') return to.path === '/'
    if (to.path === route) return true
    const prefix = route.endsWith('/') ? route : `${route}/`
    return to.path.startsWith(prefix)
  })

  // Allow access to public routes without touching Pinia-backed composables
  if (isPublicRoute) return

  // For protected routes, check authentication status
  const { isAuthenticated } = useAzureAdAuth()
  if (!isAuthenticated.value) {
    console.log('Not authenticated, redirecting to login page')
    return navigateTo('/auth/login')
  }
})
